import React, {useState} from 'react';
import {Button, Form, Modal} from "react-bootstrap";
import vacansyService from "../../../api/vacancy.api";
import applicationService from "../../../api/application.api";
import {getErrorMessage} from "../../../helpers/errorMessage";
import {toast} from "react-toastify";

type Props = {
    item: any
    update: () => void;
    type: string
};

const DeleteActions = ({update, item, type}: Props) => {
    const [show, setShow] = useState(false);



    const handleClose = () => {
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const handleDelete = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            if (type === "vacancy") {
                await vacansyService.delete(item.id);
                toast.success("Шаблон вакансии успешно удален");
            } else if (type === "application") {
                await applicationService.delete(item.id);
                toast.success("Шаблон заявки успешно удален");
            }

            await update();
            handleClose();
        } catch (error) {
            toast.error(getErrorMessage(e));
        }
    };

    return (
        <div>
            <button
                className="dropdown-item"
                onClick={(e) => {
                    e.preventDefault();
                    handleShow();
                }}
            >
                Удалить шаблон
            </button>

            <Modal size="lg" show={show} onHide={handleClose} keyboard={true}>
                <Modal.Header closeButton>
                    <Modal.Title>Удалить шаблон {item.position}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleDelete}>
                        <Button variant="danger" type="submit">
                            Удалить
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default DeleteActions;